export default [
  {
    inputs: [
      {
        internalType: 'address',
        name: 'token',
        type: 'address',
      },
    ],
    name: 'UnsupportedMarginToken',
    type: 'error',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'funder',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'token',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
    ],
    name: 'AddMarginPoolBalance',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'pairBase',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'lastBlock',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'int256',
        name: 'longAccFundingFeePerShare',
        type: 'int256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'marketPrice',
        type: 'uint256',
      },
    ],
    name: 'UpdatePairAccFundingFeePerShare',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'pairBase',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'lastBlock',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'longQty',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'shortQty',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'int256',
        name: 'longAccFundingFeePerShare',
        type: 'int256',
      },
      {
        indexed: false,
        internalType: 'uint128',
        name: 'lpLongAvgPrice',
        type: 'uint128',
      },
      {
        indexed: false,
        internalType: 'uint128',
        name: 'lpShortAvgPrice',
        type: 'uint128',
      },
    ],
    name: 'UpdatePairPositionInfo',
    type: 'event',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'token',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
    ],
    name: 'addMarginPoolBalance',
    outputs: [],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'pairBase',
        type: 'address',
      },
    ],
    name: 'getPairQty',
    outputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'longQty',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'shortQty',
            type: 'uint256',
          },
        ],
        internalType: 'struct ITradingCore.PairQty',
        name: '',
        type: 'tuple',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'pairBase',
        type: 'address',
      },
    ],
    name: 'lastLongAccFundingFeePerShare',
    outputs: [
      {
        internalType: 'int256',
        name: 'longAccFundingFeePerShare',
        type: 'int256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'lpNotionalUsd',
    outputs: [
      {
        internalType: 'uint256',
        name: 'notionalUsd',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'targetToken',
        type: 'address',
      },
    ],
    name: 'lpUnrealizedPnlUsd',
    outputs: [
      {
        internalType: 'int256',
        name: 'totalUsd',
        type: 'int256',
      },
      {
        internalType: 'int256',
        name: 'tokenUsd',
        type: 'int256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'lpUnrealizedPnlUsd',
    outputs: [
      {
        internalType: 'int256',
        name: 'totalUsd',
        type: 'int256',
      },
      {
        components: [
          {
            internalType: 'address',
            name: 'token',
            type: 'address',
          },
          {
            internalType: 'int256',
            name: 'unPnlUsd',
            type: 'int256',
          },
        ],
        internalType: 'struct ITradingCore.LpMarginTokenUnPnl[]',
        name: 'tokenUnPnlUsd',
        type: 'tuple[]',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'pairBase',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'marketPrice',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'qty',
        type: 'uint256',
      },
      {
        internalType: 'bool',
        name: 'isLong',
        type: 'bool',
      },
    ],
    name: 'slippagePrice',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'longQty',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'shortQty',
            type: 'uint256',
          },
        ],
        internalType: 'struct ITradingCore.PairQty',
        name: 'pairQty',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'onePercentDepthAboveUsd',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'onePercentDepthBelowUsd',
            type: 'uint256',
          },
          {
            internalType: 'uint16',
            name: 'slippageLongP',
            type: 'uint16',
          },
          {
            internalType: 'uint16',
            name: 'slippageShortP',
            type: 'uint16',
          },
          {
            internalType: 'uint256',
            name: 'longThresholdUsd',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'shortThresholdUsd',
            type: 'uint256',
          },
          {
            internalType: 'enum SlippageType',
            name: 'slippageType',
            type: 'uint8',
          },
        ],
        internalType: 'struct SlippageConfigView',
        name: 'sc',
        type: 'tuple',
      },
      {
        internalType: 'uint256',
        name: 'marketPrice',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'qty',
        type: 'uint256',
      },
      {
        internalType: 'bool',
        name: 'isLong',
        type: 'bool',
      },
    ],
    name: 'slippagePrice',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'pure',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'pairBase',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'limitPrice',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'qty',
        type: 'uint256',
      },
      {
        internalType: 'bool',
        name: 'isLong',
        type: 'bool',
      },
    ],
    name: 'triggerPrice',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'longQty',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'shortQty',
            type: 'uint256',
          },
        ],
        internalType: 'struct ITradingCore.PairQty',
        name: 'pairQty',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'onePercentDepthAboveUsd',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'onePercentDepthBelowUsd',
            type: 'uint256',
          },
          {
            internalType: 'uint16',
            name: 'slippageLongP',
            type: 'uint16',
          },
          {
            internalType: 'uint16',
            name: 'slippageShortP',
            type: 'uint16',
          },
          {
            internalType: 'uint256',
            name: 'longThresholdUsd',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'shortThresholdUsd',
            type: 'uint256',
          },
          {
            internalType: 'enum SlippageType',
            name: 'slippageType',
            type: 'uint8',
          },
        ],
        internalType: 'struct SlippageConfigView',
        name: 'sc',
        type: 'tuple',
      },
      {
        internalType: 'uint256',
        name: 'limitPrice',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'qty',
        type: 'uint256',
      },
      {
        internalType: 'bool',
        name: 'isLong',
        type: 'bool',
      },
    ],
    name: 'triggerPrice',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'pure',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'pairBase',
        type: 'address',
      },
    ],
    name: 'updatePairPositionInfo',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'pairBase',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'userPrice',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'marketPrice',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'qty',
        type: 'uint256',
      },
      {
        internalType: 'bool',
        name: 'isLong',
        type: 'bool',
      },
      {
        internalType: 'bool',
        name: 'isOpen',
        type: 'bool',
      },
    ],
    name: 'updatePairPositionInfo',
    outputs: [
      {
        internalType: 'int256',
        name: 'longAccFundingFeePerShare',
        type: 'int256',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
] as const;
